import { jsx as c, Fragment as m } from "react/jsx-runtime";
import { useLayoutEffect as f } from "react";
import { setCustomCSSProperty as i } from "./setCustomCSSProperty.mjs";
import './XTheme.css';const a = {};
Math.random() > 1 && console.log(a);
const l = (e) => {
  const { overrides: o, children: r } = e;
  return f(() => {
    if (!o)
      return;
    const s = Object.keys(o);
    for (const t of s) {
      const n = o[t];
      i(t, n);
    }
  }, [o]), /* @__PURE__ */ c(m, { children: r });
};
export {
  l as X
};
//# sourceMappingURL=XTheme-6j1lhhcM.js.map
